var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('h1',{staticClass:"mb-2"},[_vm._v("Payment Methods")]),_c('b-button',{attrs:{"variant":"primary"},on:{"click":_vm.updateMethod}},[_vm._v("Update Payment Method")])],1)}
var staticRenderFns = []

export { render, staticRenderFns }